import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { Reveal } from "@/components/ScrollReveal";
import FormateurPublicCard from "@/components/formateur/FormateurPublicCard";

export default function CursusFormateurs({ slug }) {
    const [formateurs, setFormateurs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        setLoading(true);
        api.get(`/cursus/${slug}/formateurs`)
            .then((r) => mounted && setFormateurs(r.data || []))
            .catch(() => mounted && setFormateurs([]))
            .finally(() => mounted && setLoading(false));
        return () => { mounted = false; };
    }, [slug]);

    return (
        <section
            className="relative bg-white py-24 md:py-32"
            data-testid="cursus-formateurs"
        >
            <div className="mx-auto max-w-7xl px-6">
                <div className="max-w-3xl">
                    <Reveal>
                        <span className="text-[11px] font-semibold uppercase tracking-[0.32em] text-brand-orange">
                            Vos formateurs
                        </span>
                        <h2 className="mt-5 font-display font-normal leading-[0.95] tracking-tightest text-brand-ink text-[40px] sm:text-5xl lg:text-[72px]">
                            Vos <em className="italic text-brand-smoke">formateurs.</em>
                        </h2>
                        <p className="mt-6 text-base text-brand-ink/70 md:text-lg">
                            Des thérapeutes qui anticipent et diversifient les approches de demain.
                        </p>
                    </Reveal>
                </div>

                {loading ? (
                    <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-3">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="h-96 animate-pulse rounded-3xl bg-brand-sand" />
                        ))}
                    </div>
                ) : formateurs.length === 0 ? (
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                        className="mt-16 rounded-3xl border border-dashed border-brand-ink/15 bg-brand-sand px-8 py-20 text-center"
                        data-testid="cursus-formateurs-empty"
                    >
                        <div className="font-display text-2xl text-brand-ink">
                            Notre équipe de formateurs experts sera bientôt présentée ici.
                        </div>
                        <div className="mt-3 text-sm text-brand-smoke">
                            En attendant, contactez-nous pour tout renseignement sur les intervenants.
                        </div>
                    </motion.div>
                ) : (
                    <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                        {formateurs.map((f, i) => (
                            <FormateurPublicCard key={f.id || f.full_name} formateur={f} index={i} variant="compact" />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}
